/* PopUpDisplayRenderer.js */

"use strict";

const _ = require('lodash');
// const ButtonControl = require("@gluenetworks/steve_ui_core").Control.Action.Button;
// const ComboBoxControl = require("@gluenetworks/steve_ui_core").Control.OptionSelection.Single.ComboBox;

class PopUpDisplayRenderer {
    constructor(model) {
        this._model = model;
        this._rootElem = document.createElement("pop-up-prefs-display");
        this._rootElem.component = this._model;
        this._rootElem.tabIndex = -1;

        this._themeCheckBox = undefined;
        this._showUnlicensedCheckBox = undefined;
        this._showSolutionNamesCheckBox = undefined;

        this._registerListeners();
        this.render();
    }
    /********************************************/
    /* START PRIVATE COMPONENT RENDERER METHODS */
    /********************************************/
    _shutdown(){
        let prom = new Promise((resolve /*,reject*/) => {
            this._unregisterListeners();
            this._model = undefined;
            this._rootElem.remove();
            this._rootElem = undefined;
            this._themeCheckBox = undefined;
            this._showUnlicensedCheckBox = undefined;
            this._showSolutionNamesCheckBox = undefined;

            resolve();
        });
        return prom;
    }
    _registerListeners(){
        this._model.addListener("Shown",this._onShown = this._onShown.bind(this));
        this._model.addListener("Focus",this._onFocus = this._onFocus.bind(this));
        this._model.addListener("Blur",this._onBlur = this._onBlur.bind(this));
        
        this._rootElem.addEventListener('focus', this._onFocusEvent = this._onFocusEvent.bind(this));
        this._rootElem.addEventListener('blur', this._onBlurEvent = this._onBlurEvent.bind(this));
        this._model.addListener("ControlUserSet", this._onControlUserSet = this._onControlUserSet.bind(this));
        this._model.addListener("SomethingElseHovered", this._closePopUp = this._closePopUp.bind(this));
        this._model.addListener("PreferencesHovered", this._showPopUp = this._showPopUp.bind(this));

        this._model.on("ApplyInitialValues", this._applyInitialValues = this._applyInitialValues.bind(this));
        this._model.on("LicensesSet", this._onLicensesSet = _.debounce(this._onLicensesSet.bind(this), 500));
        
    }
    _unregisterListeners(){
        
        this._model.removeListener("Shown",this._onShown);
        this._model.removeListener("Focus",this._onFocus);
        this._model.removeListener("Blur",this._onBlur);
        this._rootElem.removeEventListener('focus', this._onFocusEvent);
        this._rootElem.removeEventListener('blur', this._onBlurEvent);
        this._model.removeEventListener("ControlUserSet", this._onControlUserSet);
        this._model.removeListener("SomethingElseHovered", this._closePopUp);
        this._model.removeListener("PreferencesHovered", this._showPopUp);

        this._model.removeListener("ApplyInitialValues", this._applyInitialValues);
        this._model.removeListener("LicensesSet", this._onLicensesSet);
    }
    /*******************************************/
    /* END PRIVATE COMPONENT RENDERER METHODS  */
    /* START PUBLIC COMPONENT RENDERER METHODS */
    /*******************************************/
    /**
     * Stateless method to completely rebuild this component from the _rootElem down.
     * @returns {Promise} An ES6 promise that lets the caller know when the component has finished rendering. If a non
     * Promise is returned the caller will assume the Renderer has completed rendering.
     */
    render(){
        let prom = new Promise((resolve/*,reject*/) => {
            const titleDiv = document.createElement("div");
            titleDiv.classList.add("title-container");
            const prefTitle = document.createElement("div");
            prefTitle.classList.add("pref-title");
            prefTitle.innerText = "Preferences";
            titleDiv.appendChild(prefTitle);

            this._rootElem.appendChild(titleDiv);
            this._rootElem.appendChild(this._generateLabel("Choose theme:"));
            this._themeCheckBox = this._generateCheckbox(["Dark", "Light"], "theme", false);
            this._rootElem.appendChild(this._themeCheckBox);
            this._rootElem.appendChild(this._generateLabel("Unlicensed solutions:"));
            this._showUnlicensedCheckBox = this._generateCheckbox(["Show", "Hide"], "unlicensed");
            this._rootElem.appendChild(this._showUnlicensedCheckBox);
            this._rootElem.appendChild(this._generateLabel("Solution names:"));
            this._showSolutionNamesCheckBox = this._generateCheckbox(["Show", "Hide"], "solution_names", true);
            this._rootElem.appendChild(this._showSolutionNamesCheckBox);

            // this._applyInitialValues();
            
            resolve();
        });
        return prom;
    }
    get rootElement(){
        return this.getRootElement();
    }
    getRootElement(){
        return this._rootElem;
    }
    get model(){
        return this.getModel();
    }
    getModel(){
        return this._model;
    }
    /*******************************************/
    /* END COMPONENT RENDERER METHODS */
    /* START HANDLER METHODS */
    /*******************************************/


    /**
     * Fired when shown state has been toggled in the model
     * @param newVal {boolean}
     * @private
     */
    _onShown(newVal){
        this._setShown(newVal);
    }

    /**
     * Fired when the user has selected a new org from the org dropdown
     * @param newVal {object|array|boolean|number|string}
     * @param oldVal {object|array|boolean|number|string}
     * @param event {event}
     * @private
     */

    /**
     * Fired when focus has been called in the model
     * @private
     */
    _onFocus(){
        this._setFocus(true);
    }

    /**
     * Fired when blur has been called in the model
     * @private
     */
    _onBlur(){
        this._setFocus(false);
    }

    /**
     * Pass the focus event up to the model
     * @param event {Event}
     * @private
     */
    _onFocusEvent(/*event*/){
        //this._model._triggerUserFocus(event);
    }

    /**
     * Pass the blur event up to the model
     * @param event {Event}
     * @private
     */
    _onBlurEvent(/*event*/){
        //this._model._triggerUserBlur(event);
    }

    _closePopUp() {
        this._setShown(false);
    }

    _showPopUp() {
        this._setShown(true);
    }

    _onControlUserSet() {
        // this._rootElem.querySelectorAll("input[type='checkbox']").forEach((checkbox) => {
        //     const type = checkbox.getAttribute("check-type");
        //     switch(type) {
        //         case "theme":
        //             this._setTheme(checkbox);
        //     }
        // });
    }
    /*******************************************/
    /* END HANDLER METHODS */
    /* START PRIVATE API METHODS */
    /*******************************************/

    // _setThemeOnForm(input) {
    //     const themeVal = this._model._homeBarContext._controlUserEntity.getTheme();
    //     input.checked = (themeVal === "DARK");
    // }

    // _setUnlicensedOnForm(input) {
    //     const themeVal = this._model._homeBarContext._controlUserEntity.getTheme();
    //     input.checked = (themeVal === "DARK");
    // }

    /**
     * Toggle the shown state
     * @param newVal {boolean}
     * @private
     */
    _setShown(newVal){
        if (newVal === true) {
            this._rootElem.classList.add('shown');
        } else {
            this._rootElem.classList.remove('shown');
        }
    }

    /**
     * Set or remove focus
     * @param newVal {boolean}
     * @private
     */
    _setFocus(newVal){
        if (newVal === true) {
            this._rootElem.focus();
        } else {
            this._rootElem.blur();
        }
    }

    _generateCheckbox(textArr, type, value = false) {

        const parentContainer = document.createElement("label"),
        checkBox = document.createElement("input"),
        sliderDiv = document.createElement("div");
        
        parentContainer.classList.add("switch");
        checkBox.setAttribute("type", "checkbox");
        checkBox.setAttribute("check-type", type);
        checkBox.checked = value;

        checkBox.addEventListener("click", this._onCheckBoxClicked = this._onCheckBoxClicked.bind(this));

        parentContainer.appendChild(checkBox);

        textArr.forEach(text => {
            const textForCheckBox = document.createElement("span");
            textForCheckBox.innerText = text;
            sliderDiv.appendChild(textForCheckBox);
        });

        sliderDiv.classList.add("slider", "round");
        parentContainer.appendChild(sliderDiv);

        return parentContainer;
    }

    _generateLabel(text) {
        const label = document.createElement("label");
        label.innerText = text;
        return label;
    }

    _onCheckBoxClicked(e) {
        const elem = e.target,
        type = elem.getAttribute('check-type'),
        val = elem.checked;

        switch(type) {
            case "solution_names": 
                this.showSolutionNameChange(val);
                break;
            case "theme":
                this.themeChange(val);
                break;
            case "unlicensed":
                this.showUnlicensedChange(val);
                break;
        }
        
    }

    showSolutionNameChange(val) {
        this._model._homeBarContext._controlUserEntity.setProperty("navShowSolutionNames", val);
        this._model._homeBarContext._controlUserEntity.update();
        // this._model._homeBarContext._renderer._toggleHideFirstLevelClass(!val);
        this._model._homeBarContext.emit("onToggleHideFirstLevel", val);
    }

    themeChange(val) {
        this._model._homeBarContext._controlUserEntity.setProperty("theme", (val ? "DARK" : "LIGHT"));
        this._model._homeBarContext._controlUserEntity.update();
        // this._model._homeBarContext._renderer._toggleTheme(!val);
        this._model._homeBarContext.emit("onToggleTheme", val);
    }

    showUnlicensedChange(val) {
        this._model._homeBarContext._controlUserEntity.setProperty("navShowUnlicensedSolutions", val);
        this._model._homeBarContext._controlUserEntity.update();
        // this._model._homeBarContext._renderer._toggleTheme(!val);
        this._model._homeBarContext.emit("onShowUnlicensed", val);
    }

    _applyInitialValues() {
        const theme = this._model._homeBarContext._controlUserEntity.getTheme ?
        this._model._homeBarContext._controlUserEntity.getTheme() :
        this._model._homeBarContext._controlUserEntity.getProperty("theme"),
        hideFirstLevel = this._model._homeBarContext._controlUserEntity.getNavShowSolutionNames ?
        this._model._homeBarContext._controlUserEntity.getNavShowSolutionNames() :
        this._model._homeBarContext._controlUserEntity.getProperty("navShowSolutionNames");
        
        this._themeCheckBox.querySelector("input[type='checkbox']").checked = (theme === "DARK");
        this._showSolutionNamesCheckBox.querySelector("input[type='checkbox']").checked = hideFirstLevel;
        
        this._model._homeBarContext.emit("onToggleTheme", (theme === "DARK"));
        this._model._homeBarContext.emit("onToggleHideFirstLevel", hideFirstLevel);

        this._onLicensesSet();
        
    }

    _onLicensesSet() {
        if(this._model._homeBarContext._controlUserEntity) {
            const showUnlicensed = this._model._homeBarContext._controlUserEntity.getNavShowUnlicensedSolutions ? 
            this._model._homeBarContext._controlUserEntity.getNavShowUnlicensedSolutions() :
            this._model._homeBarContext._controlUserEntity.getProperty("navShowUnlicensedSolutions");

            this._showUnlicensedCheckBox.querySelector("input[type='checkbox']").checked = _.isUndefined(showUnlicensed) ? true : showUnlicensed;

            this._model._homeBarContext.emit("onShowUnlicensed", (_.isUndefined(showUnlicensed) ? true : showUnlicensed));
        }
    }
    /*******************************************/
    /*  END PRIVATE API METHODS */
    /*******************************************/
}

module.exports = PopUpDisplayRenderer;